module.exports = __webpack_public_path__ + "img/15.82036294.png";